import { SsoPlatform } from '../types/sso.types';

/**
 * Parse SSO platforms from environment variable
 * Format: domain,plateformName,logoUrl[;domain2,plateformName2,logoUrl2]
 * Example: dcx.example.com,DCX,/platforms/dcx.png;ct.example.com,CT,https://ct.example.com/logo.png
 */
export function getSsoPlatforms(): SsoPlatform[] {
  const platformsStr = process.env.REACT_APP_SSO_PLATFORMS || '';

  if (!platformsStr) {
    return [];
  }

  return platformsStr.split(';').map((platformStr) => {
    const [domain, plateformName, logoUrl] = platformStr
      .split(',')
      .map((s) => s.trim());
    return { domain, plateformName, logoUrl };
  });
}

/**
 * Normalize an SSO target while preserving the path required by the platform.
 * The protocol and a trailing slash are optional in the configuration.
 */
export function normalizeSsoTarget(target: string): string {
  return target
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '');
}

/**
 * Find a platform by its complete configured target (host and path).
 */
export function findPlatformByDomain(
  urlOrDomain: string,
): SsoPlatform | undefined {
  const target = normalizeSsoTarget(urlOrDomain);
  const platforms = getSsoPlatforms();
  return platforms.find(
    (platform) => normalizeSsoTarget(platform.domain) === target,
  );
}

/**
 * Validate if domain/URL is authorized for SSO
 */
export function isValidSsoDomain(urlOrDomain: string): boolean {
  return !!findPlatformByDomain(urlOrDomain);
}
